import Billing from 'components/billingSummary';
const BillingSummary = () => {
  return <Billing />;
};

export default BillingSummary;
